<template>
  <form class="needs-validation row mb-3 mx-0" @submit.prevent="confirm(true)" novalidate>
    <section class="col-12 col-md bg-white rounded p-4 p-xl-5">
      <div role="alert" class="alert alert-warning text-center mb-4">
        <p class="mb-0"><strong>Running short on time?</strong> Don't worry! You can save and continue later.</p>
      </div>
      <div role="alert" class="alert alert-info text-center mb-4">
        <p class="mb-0"><strong>Are there members here that shouldn't be?</strong> Please contact us after completing the form.</p>
      </div>
      <div role="alert" class="alert alert-warning" v-if="errors">{{errors}}</div>
      <h1 class="h3 mb-2">Your Members</h1>
      <p class="mb-4">The following <strong>members</strong> are registered under your account. <br>Please check all details.</p>
      <div v-if="userInfo.length > 0">
        <div class="row" v-for="(user, index) in userInfo" :key="index">

          <div class="col-12">
            <button @click="selectedSection = selectedSection === index ? -1 : index" :class="['btn btn-link btn-block border-bottom rounded-0 py-3 text-left text-dark d-flex justify-content-between align-items-center', selectedSection === index ? 'bg-lighter' : '']" type="button" :aria-expanded="selectedSection === index" :aria-controls="'memberSection' + index">
              <h2 class="h5 mb-0" :id="'member' + index">Member {{index + 1}}</h2>
              <svg v-if="index in fieldsValidity ? !fieldsValidity[index] : false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" width="22" height="21"><g class="currentLayer"><g><path fill="#AA2D41" d="M8.4749994 9.7999992c-.3 0-.5-.2-.5-.5v-3.6c0-.3.2-.5.5-.5s.5.2.5.5v3.6c0 .3-.2.5-.5.5zM8.4749994 12.3999992c-.1 0-.3 0-.4-.1-.1-.1-.1-.2-.1-.4 0-.1 0-.3.1-.4.2-.2.5-.2.7 0 .1.1.1.2.1.4 0 .1-.1.3-.2.4.1.1-.1.1-.2.1z"></path><g><path fill="#AA2D41" d="M14.3749994 15.4999992h-11.8c-.9 0-1.8-.5-2.2-1.3-.5-.8-.5-1.8 0-2.6l5.9-10.3c.5-.8 1.3-1.3 2.2-1.3s1.8.5 2.2 1.3l5.9 10.3c.5.8.5 1.8 0 2.6-.4.8-1.2 1.3-2.2 1.3zm-5.9-14.4c-.6 0-1.1.3-1.3.8l-5.9 10.3c-.3.5-.3 1.1 0 1.6s.8.8 1.3.8h11.9c.6 0 1.1-.3 1.3-.8.3-.5.3-1.1 0-1.6l-5.9-10.3c-.3-.5-.8-.8-1.4-.8z"></path></g></g></g></svg>
            </button>
          </div>

          <VueSlideToggle class="row w-100 align-items-start mx-0" :open="selectedSection === index" :id="'memberSection' + index" :aria-labelledby="'member' + index">
          
            <div class="col-12 col-md-6 row no-gutters pr-xl-4 pt-3">
              <div class="col-12 col-md-auto form-group">
                <label :for="'title' + index">Title</label>
                <select :ref="'title' + index" class="form-control" :id="'title' + index" @change="updateValidity(index)" required v-model="userInfo[index].title">
                  <option disabled></option>
                  <option value="Mr">Mr</option>
                  <option value="Ms">Ms</option>
                  <option value="Miss">Miss</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Dr">Dr</option>
                </select>
                <div class="invalid-tooltip">Please include the title.</div>
              </div>

              <div class="col-12 col-md pl-md-4 form-group">
                <label :for="'firstName' + index">First Name</label>
                <input :ref="'firstName' + index" type="text" class="form-control" :id="'firstName' + index" @change="updateValidity(index)" required v-model="userInfo[index].first_name">
                <div class="invalid-tooltip">Please include the First Name.</div>
              </div>
            </div>

            <div class="col-12 col-md-6 pl-xl-4 form-group pt-md-3">
              <label :for="'lastName' + index">Last Name</label>
              <input :ref="'lastName' + index" type="text" class="form-control" :id="'lastName' + index" @change="updateValidity(index)" required v-model="userInfo[index].last_name">
              <div class="invalid-tooltip">Please include the Last Name.</div>
            </div>
            <div class="col-12 col-md-6 pr-xl-4 form-group">
              <label :for="'dateOfBirth' + index">Date of Birth</label>
              <input :ref="'dob' + index" v-model="userInfo[index].dob" @change="checkDoB(index);updateValidity(index)" :max="today()" required :class="['form-control form-date', errorStatus === 'validation_error' ? 'is-invalid' : '']" :id="'dateOfBirth' + index" type="date" :placeholder="[isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy']" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" value="1988-01-01">
              <div class="invalid-tooltip">Please include the Date of Birth{{ isLegacy() ? ' in the format yyyy-mm-dd' : ''}}.</div>
            </div>
            <div class="col-12 col-md-6 pl-xl-4 form-group">
              <label :for="'gender' + index">Gender</label>
              <select :ref="'gender' + index" class="form-control" :id="'gender' + index" @change="updateValidity(index)" required v-model="userInfo[index].gender">
                <option disabled></option>
                <option>Male</option>
                <option>Female</option>
                <option>Unspecified</option>
              </select>
              <div class="invalid-tooltip">Please include the Gender.</div>
            </div>
            <div class="col-12"><hr class="mb-0"></div>
          </VueSlideToggle>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col-12">
          <div role="alert" class="alert alert-info text-center">
            <p class="mb-0">There are no other members in our records. Members can be added later.</p>
          </div>
        </div>
      </div>

      <div class="row mt-3 mt-xl-4">
        
        <div class="col-12" v-if="success">
          <div role="alert" class="alert alert-success text-center">{{success}}</div>
        </div>
        <div class="col-12" v-if="fieldsValidity.includes(false)">
          <div role="alert" class="alert alert-danger text-center">Please complete the member details above.</div>
        </div>
        <div class="col-12 d-lg-flex justify-content-end align-items-center mt-md-3">
          <p class="pr-lg-3 mb-2 mb-lg-0 text-center">Take me to Account Overview</p>
          <button :class="['btn btn-block-mob mb-2 mb-lg-0 px-md-5', processing ? 'btn-primary-dark' : 'btn-primary', userInfo.length > 0 ? 'mr-lg-2' : '']" type="submit" @click="handleSubmit();confirm(true)">
            {{ !processing ? 'Confirm' : '' }}
            <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
          </button>
          <button :class="['btn btn-block-mob px-md-5', processing2 ? 'btn-primary-dark' : 'btn-outline-primary']" type="submit" @click.prevent="saveData(false)" v-if="userInfo.length > 0">
            {{ !processing2 ? 'Save & Continue Later' : '' }}
            <div v-if="processing2" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
          </button>
        </div>
      </div>
    </section>
  </form>
</template>

<script>
import axios from 'axios'
import { VueSlideToggle } from 'vue-slide-toggle'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import LEGACYBROWSERS from '@/mixins/legacyBrowsers.js'

export default {
  mixins: [HANDLESUBMIT, LEGACYBROWSERS],
  components: {
    VueSlideToggle
  },
  props: ['user'],
  data() {
    return {
      userInfo: this.user.secondaries ? this.user.secondaries : [],
      fieldsValidity: [],
      selectedSection: 0,
      processing: false,
      processing2: false,
      success: '',
      errors: '',
      errorStatus: '',
      dateOfBirth: ''
    }
  },
  mounted() { window.scrollTo(0, 0) },
  watch: {
    userInfo: {
      deep: true,
      handler() {

      }
    }
  },
  methods: {
    checkFieldsValidity(index) {
      let tempFieldValidity = this.$refs[`title${index}`][0].checkValidity()
      tempFieldValidity = this.$refs[`firstName${index}`][0].checkValidity() ? tempFieldValidity : false
      tempFieldValidity = this.$refs[`lastName${index}`][0].checkValidity() ? tempFieldValidity : false
      tempFieldValidity = this.$refs[`dob${index}`][0].checkValidity() ? tempFieldValidity : false
      tempFieldValidity = this.$refs[`gender${index}`][0].checkValidity() ? tempFieldValidity : false

      this.fieldsValidity.splice(index, 1, tempFieldValidity)
    },
    updateValidity(index) {
      if (index in this.fieldsValidity) {
        this.checkFieldsValidity(index)
      }
    },
    checkDoB(index) {
      this.dateOfBirth = this.userInfo[index].dob
    },
    confirm(isComplete) {
      this.success = ''
      setTimeout(() => {
        if (this.formComplete) {
          if (this.userInfo.length > 0) {
            this.saveData(isComplete)
          } else {
            this.$emit('proceed')
          }
        } else {
          this.userInfo.forEach((user, index) => {
            this.checkFieldsValidity(index)
          })
        }
      }, 10)
    },
    saveData(isComplete) {
      if (isComplete) {
        this.processing = true
      } else {
        this.processing2 = true
      }
      axios.post(`${this.$api}/onboarding/secondaries-${isComplete ? 'complete' : 'incomplete'}`, { secondaries: this.userInfo }).then((response) => {
        if (isComplete) {
          this.processing = false
        } else {
          this.processing2 = false
          this.$router.push('/login')
        }
        // eslint-disable-next-line
        console.log(response)
        if (response.data.status === 'success') {
          // Done
          this.errors = ''
          this.errorStatus = ''
          if (isComplete) {
            this.$emit('proceed')
          } else {
            this.success = 'Your data has been saved.'
          }
        } else if (response.data.status === 'validation_error' && response.data.errors.dob) {
          // DoB
          this.success = ''
          this.errorStatus = 'validation_error'
          this.errors = `Please include your Date of Birth in the format${this.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy'}.`
        } else {
          // Error
          this.success = ''
          this.errors = 'Please ensure all fields are completed.'
        }
      }).catch((error) => {
        if (isComplete) {
          this.processing = false
        } else {
          this.processing2 = false
        }
        this.success = ''
        this.errors = 'There was a server error. Please try again later.'
        this.errorStatus = ''
        // eslint-disable-next-line
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-link.btn-block {

  &:hover,
  &:focus {
    text-decoration: none;
    background-color: var(--lighter) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Account/LoginOnce/LoginOnce2.vue